import {
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
  FETCH_VIDEOS_FAILURE,
} from "../actions/videoaction";

const initialState = {
  videos: [],
  Loading: true,
};

const videoReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VIDEOS_SUCCESS:
      return { ...state, videos: action.payload, Loading: false };
    case FETCH_VIDEOS_REQUEST:
      return { ...state, Loading: true };
    default:
      return state;
  }
};

export default videoReducer;
